import styled from 'styled-components';

import Affix from '@components/Affix/next';
import { Row } from '@components/formStyles';
import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';

export const ListWrapper = styled(Row)`
  width: 100%;
  margin: 0 auto 0 auto;
  display: flex;
  padding: 0;
  overflow-x: hidden;
  justify-content: center;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
    grid-template-columns: 260px 960px;
    padding: 0 100px;
    gap: 0 20px;
  }
`;
export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const FAQWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  display: flex;
  flex-direction: column;
  padding: 20px 15px;

  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 20px calc((100% - ${LANDING_BREAKPOINT}) / 2);
    justify-content: center;
  }
`;
export const ItemsRowWrapper = styled.div`
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }
`;

export const SearchWrapper = styled.div<{ sticky?: boolean }>`
  margin-top: ${({ sticky }) => (sticky ? '0' : ' 20px')};
  padding: ${({ sticky }) => (sticky ? '10px 0  0 0' : '0 0 12px 0')};
  z-index: 999999;
  position: ${({ sticky }) => (sticky ? 'fixed' : 'unset')};
  width: ${({ sticky }) => (sticky ? '100vw' : 'fit-content')};
  left: 0;
  top: ${({ sticky }) => (sticky ? '0' : '-100px')};
  transition: top 0.3s;
  display: flex;
  flex-direction: column;
  background-color: ${({ sticky, theme }) =>
    sticky ? theme.palette.white : 'transparent'};
  border-bottom: ${({ sticky, theme }) =>
    sticky ? 'none' : `2px solid ${theme.palette.white}`};
  box-shadow: ${({ sticky }) => (sticky ? '0px 10px 20px 0px #0000001a' : '0')};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
  min-height: 92px;
`;

export const KocAilemContainer = styled.div`
  max-width: 1270px;
  width: 100%;
  margin: auto;
`;

export const SearchWrapperHidden = styled.div`
  margin: 0 auto;
  margin-top: 20px;
  width: 100%;
  height: 78px;
`;

export const SearchWrapperContent = styled.div<{ sticky?: boolean }>`
  max-width: 1240px;
  ${({ sticky }) => sticky && 'width: 1240px; '};
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;
export const StickyLogoBox = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  @media only screen and (max-width: 1100px) {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }
`;

export const StickyText = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  margin-left: 20px;
`;

export const NotFoundWrapper = styled.div`
  width: 40%;
  padding: 100px 0 0 0;
  margin: 0 auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 85%;
    margin-bottom: 80px;
  }
`;

export const ListingItemContainer = styled.div`
  display: grid;
  flex-wrap: wrap;
  margin-bottom: 20px;
  justify-content: space-around;
  width: 100%;
  grid-auto-rows: auto;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 0px 17px;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 10px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
    grid-template-columns: 960px;
    grid-template-rows: auto;
    grid-auto-rows: auto;
    gap: 0px;
    width: auto;
    justify-content: flex-start;
    padding-left: 0;
    padding-right: 0;
    margin-top: 0px;
  }
`;

export const ListingItemCardWrapper = styled.div`
  height: 685px;
  width: 100%;
  margin: 0 auto 20px auto;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 100%;
    margin: 0;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 100%;
  }
`;

export const ListingCampaignBanner = styled.div`
  width: 960px;
  margin-top: 5px;
  margin-bottom: 5px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 1003px;
    width: 100%;
    margin: 3px auto 3px auto;
    & > div {
      padding: 0 !important;
    }
  }

  @media (max-width: 1019px) {
    max-width: 660px;
    width: 100%;
    margin: 3px auto 3px auto;
  }

  @media only screen and (max-width: 690px) {
    max-width: 93%;
  }
  *,
  :after,
  :before {
    border-radius: 8px;
  }
`;

export const LoadMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;
export const LoadMoreButton = styled.button`
  padding: 18px 40px;
  cursor: pointer;
  border-radius: 2px;
  border: solid 1px ${(p) => p.theme.palette.eclipse};
  background-color: white;
  width: 220px;
  &:disabled {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
`;

export const ResponsiveBox = styled.div`
  width: 100%;
  padding: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
`;

export const ResponsiveBoxContainer = styled.div`
  width: 100%;
  padding: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  position: relative;
  border-radius: 8px;
`;

export const Text = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: flex-end;
  color: ${({ theme }) => theme.palette.Blue600};
  gap: 8px;
  font-size: 16px;
  line-height: 20.11px;
`;
export const ResponsiveBoxAffix = styled(Affix)<{ sticky?: boolean }>`
  position: ${({ sticky }) => (sticky ? 'fixed' : 'static')} !important;
`;

export const ResponsiveSearchBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`;

export const ResponsiveSearchBoxItem = styled.div`
  align-items: center;
`;

export const ResponsiveSearchBoxLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.matterHorn};
`;

export const ResponsiveSearchBoxLabelBig = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  display: inline-block;
  margin-bottom: 10px;
`;

export const ResponsiveSearchBoxEdit = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const ResponsiveSearchBoxEditLabel = styled.span`
  margin: 1px 5px 1px 0;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.B300};
  text-decoration-line: underline;
  text-wrap: nowrap;
`;
export const SearchIconWrapper = styled.span`
  margin-top: 5px;
`;

export const ResponsiveSearchBoxSubLabel = styled.span`
  font-weight: normal;
  display: inline-block;
`;

export const SkeletonItemsWrapper = styled.div`
  width: 960px;
  display: grid;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
    justify-items: center;
  }
`;

export const ResponsiveSearchBoxText = styled.div`
  margin: 1px 5px 1px 0;
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.B300};
`;

export const ResponsiveSearchBodyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`;
export const SepareteBottom = styled.div`
  padding-top: 50px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-top: 0px;
  }
`;

export const ListingCancelBanner = styled.div`
  with: 100%;
  margin-bottom: 10px;
`;
